import request from '@/utils/request'

export function getMemberLevelList(data) {
  return request.post('/member-level/list', data)
}

export function getMemberTypeList(data) {
  return request.post('/member-type/list', data)
}

export function getMemberDiscountList(data) {
  return request.post('/member-goods-type/list', data)
}

export function modifyMemberDiscount(data) {
  return request.post('/member-goods-type/modify', data)
}

export function getMemberList(data) {
  return request.post('/member/list', data)
}

export function addMember(data) {
  return request.post('/member/add', data)
}

export function modifyMember(data) {
  return request.post('/member/modify', data)
}



// WEBPACK FOOTER //
// ./src/api/settings/member.js